module.exports = __webpack_public_path__ + "img/wuguzaliang.0d30c540.jpg";